import { render, staticRenderFns } from "./close.vue?vue&type=template&id=bc0bd8ae&scoped=true&"
import script from "./close.vue?vue&type=script&lang=js&"
export * from "./close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0bd8ae",
  null
  
)

export default component.exports